<script lang="ts">
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import * as numeral from 'numeral';
    import { clearSession } from '../../session';
    import Header from './Header.svelte';
    import HeaderThemes from './HeaderThemes.svelte';
    import Footer from './Footer.svelte';
    import FooterThemes from './Footerthemes.svelte';
    import Clipboard from "svelte-clipboard";
    import Fa from 'svelte-fa'
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faSpinner,faCopy } from '@fortawesome/free-solid-svg-icons';
    document.body.scrollIntoView();
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    let loading = true
    let isList = false
    let member = <any>{}
    let names;
    let balance = 0
    let balance_hold = 0

    async function getMember() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getmember", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            loading = false
            member = json.payload
            isList = true
		} else {

            throw new Error(json);
		}
    }
    async function getBalance() {
   
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getbalance", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            
            balance = json.payload.balance.toLocaleString('th-TH')
            balance_hold = json.payload.balance_hold.toLocaleString('th-TH')

		} else {

            throw new Error(json);
		}
    }
   async function Logout() {
    loading = true
            clearSession();
            push('/auth');
   }
    
    let promise
    
    $: {
        promise = getMember()
        getBalance()
    }

</script>
<div class="default-home">
<div class="row  mb-5" style="background-image: url('{dataSetting.background}'); background-size:cover; background-repeat: no-repeat; background-position: center top;">
    <Header />
    
   
    <div class="col-12 text-center mt-2" ><h4 class="header-n">ข้อมูลส่วนตัว</h4></div>
        <div class="col-12" style="min-height: 500px;">
        {#if loading}
        <div class="text-center mt-2" style="">
            <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
        </div>
        {/if}
        {#if !loading}
        <div class="card mt-2 bg-black">
            <div class="card-body text-start">
                <div class="row">
                    <div class="col-sm-12"></div>
                    <div class="col-sm-12 text-center">
                        <span class="text-warning">กระเป๋าหลัก</span>
                        <h6 class="text-white">฿ {balance}</h6>
                        <span class="text-warning">กระเป๋าสำรอง</span>
                        <h6 class="text-white">฿ {balance_hold}</h6>
                    </div>
                </div>
                
            </div>
        </div>
        <div class="card mt-3 bg-black">
            <div class="card-body text-start">
                {#if isList}
                <div class="row">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-8">
                        <span class="text-warning">ชื่อ</span>
                        <h6 class="text-white">{member.member.member_name}</h6>
                        <hr class="text-white" />
                        <span class="text-warning">Username</span>
                        <h6 class="text-white">{member.member.member_username}</h6>
                        
                        <hr class="text-white" />
                        <span class="text-warning">ธนาคาร</span>
                        <br />
                        <br />
                        {#each member.allbank as datalist}
                            
                        
                        <div class="row mb-2">
                            <div class="col-4"><img src="./build/images/bank/{datalist.bankcode}.png" class="img-fluid" style="max-width: 100%;"></div>
                            <div class="col-8 text-white">
                                <span>{member.member.member_name}</span><br />
                                <span>{datalist.member_acc}</span>
                            </div>
                        </div>
                        {/each}

                    </div>
                </div>
                {/if}
                
            </div>
        </div>
        <div class="row mb-5">
            <div class="col-12 d-grid gap-2 mt-4 mb-5">
                <button type="button" class="btn btn-danger btn-block rounded-pill btn-gd2" on:click={() => Logout()}>ออกจากระบบ</button>
            </div>
        </div>
        {/if}
    </div>
 
</div>
<Footer />
</div>
<div class="themes-home" style="display: none;">
    <div class="row mb-3 blog-settings">
        <HeaderThemes/>
        <div class="col-12 text-center" ><h4 class="head-title">ข้อมูลส่วนตัว</h4></div>
            <div class="col-12" style="min-height: 500px;">
            {#if loading}
            <div class="text-center mt-2" style="">
                <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
            </div>
            {/if}
            {#if !loading}
            <div class="card mt-2 bg-black">
                <div class="card-body text-start">
                    <div class="row">
                        <div class="col-sm-12"></div>
                        <div class="col-sm-12 text-center">
                            <span class="text-warning">กระเป๋าหลัก</span>
                            <h6 class="text-white">฿ {balance}</h6>
                            <span class="text-warning">กระเป๋าสำรอง</span>
                            <h6 class="text-white">฿ {balance_hold}</h6>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class="card mt-3 bg-black">
                <div class="card-body text-start">
                    {#if isList}
                    <div class="row">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-8">
                            <span class="text-warning">ชื่อ</span>
                            <h6 class="text-white">{member.member.member_name}</h6>
                            <hr class="text-white" />
                            <span class="text-warning">Username</span>
                            <h6 class="text-white">{member.member.member_username}</h6>
                            
                            <hr class="text-white" />
                            <span class="text-warning">ธนาคาร</span>
                            <br />
                            {#each member.allbank as datalist}
                            <div class="row mb-2">
                                <div class="col-4"><img src="./build/images/bank/{datalist.bankcode}.png" class="img-fluid" style="max-width: 100%;"></div>
                                <div class="col-8 text-white">
                                    <span>{member.member.member_name}</span><br />
                                    <span>{datalist.member_acc}</span>
                                </div>
                            </div>
                            {/each}
    
                        </div>
                    </div>
                    {/if}
                    
                </div>
            </div>
            <div class="row mb-5">
                <div class="col-12 d-grid gap-2 mt-4 mb-5">
                    <button type="button" class="btn btn-danger btn-block rounded-pill btn-gd2" on:click={() => Logout()}>ออกจากระบบ</button>
                </div>
            </div>
            {/if}
        </div>
    </div>
</div>
<div class="themes-home-section" style="display: none;display:flex;">
    
</div>
<div class="footer-themes" style="display: none;">
    <FooterThemes />
</div>
<style>
    .btn-gd{
        --bs-btn-padding-y:0.1rem; --bs-btn-padding-x:0.3rem; --bs-btn-font-size:0.6rem;
        font-weight: 300;
    }
    .bg-dk{
        background-color: black;
    }
    .text-sm{
        font-weight: 300;
        font-size: 0.6rem;
    }
    .pointer{
        cursor: pointer;
    }
    .bg-black{
        background: #000000ad !important;
    }
</style>